module.exports = __webpack_public_path__ + "media/vuesrc/apps/auth/images/reset-icon-243e5bfd1bf5d5b535d3fe18b73ce060.svg";